
interface BadgeProps {
  children: React.ReactNode;
  variant?: 'yellow' | 'black' | 'gray';
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export default function Badge({ children, variant = 'yellow', size = 'md', className = '' }: BadgeProps) {
  const baseClasses = 'rounded-full font-bold text-center flex items-center justify-center';
  
  const variantClasses = {
    yellow: 'bg-yellow-400 text-black',
    black: 'bg-black text-white',
    gray: 'bg-gray-100 text-gray-800'
  };
  
  const sizeClasses = {
    sm: 'w-16 h-16 text-xs',
    md: 'w-20 h-20 text-sm',
    lg: 'w-24 h-24 text-base'
  };
  
  return (
    <div className={`${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${className}`}>
      {children}
    </div>
  );
}
